import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { Controller, useWatch } from 'react-hook-form';
import { Select } from '@ofqual/portal-components/components/Select';
import { SectionProps } from './SectionProps';
import { Error } from '../common/Error';
import { useLookup } from '@ofqual/portal-core/core/hooks';
import {
  generalConditionsService,
  qualificationConditionsService,
  subjectConditionsService,
} from '../../services';
import { SocItemDetailsAo } from '../../domain/SocItemDetailsAo';

type ConditionsProps = {
  type: string;
};

export const Conditions: React.FC<
  SectionProps<SocItemDetailsAo> & ConditionsProps
> = ({
  control,
  errors,
  disabled,
  lookupTracker,
  type,
  formState: { isSubmitted },
  registerCustomError,
  trigger
}) => {
  const [
    generalConditionsLookup,
    qualificationConditionsLookup,
    subjectConditionsLookup,
  ] = useLookup(
    generalConditionsService,
    qualificationConditionsService,
    subjectConditionsService,
    );


  const general = useWatch<number[]>({
    control,
    name: `soc${type}NonCompliantGeneralCondition`,
  });

  const qual = useWatch<number[]>({
    control,
    name: `soc${type}NonCompliantQualCondition`,
  });

  const subject = useWatch<number[]>({
    control,
    name: `soc${type}NonCompliantSubjectCondition`,
  });


  const isValueSelected =
    !!(general && general?.length) ||
    !!(qual && qual.length) ||
    !!(subject && subject.length);

  useEffect(() => {
    if (isSubmitted)
      trigger(`soc${type}ConditionsGlobal`);

    registerCustomError(`soc${type}ConditionsGlobal`, !isValueSelected);
  }, [registerCustomError, isValueSelected, type]);


  return (
    <>
      {/* con job to register an proper error  */}
      <Grid item xs={12}>
        <Controller
          control={control}
          name={`soc${type}ConditionsGlobal`}
          rules={{ required: !isValueSelected }}
          as={
            <div></div>
          }
        />
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name={`soc${type}NonCompliantGeneralCondition`}
          as={
            <Select
              label="General Conditions"
              readOnly={disabled}
              selectVariant="multiple"
              datatest={`soc${type}NonCompliantGeneralCondition`}
              lookupTracker={lookupTracker}
            >
              {generalConditionsLookup}
            </Select>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          control={control}
          name={`soc${type}NonCompliantQualCondition`}
          as={
            <Select
              label="Qualification Conditions"
              readOnly={disabled}
              selectVariant="multiple"
              datatest={`soc${type}NonCompliantQualCondition`}
              lookupTracker={lookupTracker}
            >
              {qualificationConditionsLookup}
            </Select>
          }
        />
      </Grid>
      <Grid item spacing={1} xs={12}>
        <Controller
          control={control}
          name={`soc${type}NonCompliantSubjectCondition`}
          as={
            <Select
              label="Subject Conditions"
              readOnly={disabled}
              selectVariant="multiple"
              datatest={`soc${type}NonCompliantSubjectCondition`}
              lookupTracker={lookupTracker}
            >
              {subjectConditionsLookup}
            </Select>
          }
        />
      </Grid>
      {
        errors[`soc${type}ConditionsGlobal`] && (
          <Error data-test={`error-soc${type} ConditionsGlobal`}>
            You must select at least one General, Qualification or Subject
            condition
          </Error>
        )
      }

    </>

  );


};
